// Import your modules
import './module/slider';
import './module/about-us';
